export default __webpack_public_path__ + "static/media/tick-white.2199c8ec.svg";